import type { TRuleWithTheme } from '@/styles/theme';

export const option: TRuleWithTheme = () => ({
    '&.ant-select-item': {
        paddingInline: '0.5rem',
    },
});
